import * as React from 'react';

import { cn } from '@codes/ui-kit/utils';

const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
    ({ className, ...props }, ref) => {
        return (
            <textarea
                className={cn(
                    'flex min-h-[60px] w-full rounded-lg border border-placeholder bg-transparent px-3 py-2 font-medium text-sm placeholder:text-[#84888F] focus-visible:outline-none focus:border-point disabled:cursor-not-allowed disabled:opacity-50 resize-none',
                    className
                )}
                ref={ref}
                {...props}
            />
        );
    }
);
Textarea.displayName = 'Textarea';

export { Textarea };
